import { http } from '@/providers/apis/http';
import { gooruSearchAPISerializer } from '@/providers/serializers/gooru-search/gooru-search';

export class GooruSearch {

  private static INSTANCE = new GooruSearch();

  private gooruSearchNamespace = 'gooru-search/rest/v2/search';

  static get instance() {
    return this.INSTANCE;
  }

  public searchCoursesBySubject(params: any) {
    const endpoint = `${this.gooruSearchNamespace}/course`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return gooruSearchAPISerializer.normalizeSearchCoursesBySubject(response.data);
    }).catch((error: any) => {
      return [];
    });
  }

}

export const gooruSearchAPI = GooruSearch.instance;
